import { render } from "./AdminKontakte.vue?vue&type=template&id=63ca9459"
import script from "./AdminKontakte.vue?vue&type=script&lang=js"
export * from "./AdminKontakte.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__